<script>
    const name = "Frederik Behrens";
    const secondaryText = "App Developer";
    const body = "I'm a developer, who's been programming since 2020. My eyes are set on making Mobile Apps with great User Experiences";

    import { onMount } from 'svelte';

    function scrollToSection(id) {
        return function () {
            const section = document.getElementById(id);
            console.log(section);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };
    }

    onMount(() => {
        // Any initialization code here
    });

</script>

<section>
    <div id='container'>
        <img id="header-image" src='https://framerusercontent.com/images/pGxOj3tCnHA4DoHoIzgkqyHFI4.png?scale-down-to=2048' alt="Apps I've made">
        <div id='container-text'>
            <h1>{name}</h1>
            <h2>{secondaryText}</h2>
            <p>{body}</p>
            <div style="margin-top: 60px;"></div>
            <button href="#about" on:click={scrollToSection('about')}  id="button-style-2">About me -></button>
            <button href="#projects" on:click={scrollToSection('projects')}  id="button-style-1">Projects -></button>
            <button href="#contact" on:click={scrollToSection('contact')}  id="button-style-3">Contact -></button>
        </div>
    </div>
</section>

<style>
    #container {
        margin-left: 5%;
        margin-right: 5%;
        width: 100vw - 20%;
        height: calc(100vh - 80px);
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #container-text {
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
    }

    #header-image {
        width: 40%;
        margin-right: 4%;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.8);
        margin-top: 24px;
        margin-bottom: 0px;
        text-align: left;
    }

    h2 {
        font-size: 22px;
        color: rgba(39, 97, 255, 0.87);
        margin-top: 8px;
        margin-bottom: 0px;
    }

    p {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.54);
        margin-top: 11px;
        margin-bottom: 0px;
    }

    #button-style-1 {
        background-color: rgba(39, 255, 230, 0.9);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-1:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-2 {
        background-color: rgba(38, 97, 255, 0.2);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-2:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-3 {
        background-color: rgba(200, 255, 120, 0.9);
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    #button-style-3:hover {
        color: rgba(0, 0, 0, 0.8);
        transition: 0.2s ease;
    }

    button {
        border-radius: 10px;
        border: 4px solid rgba(0, 0, 0, 0.8);
        padding: 24px 12px;
        width: 50%;
        font-weight: bold;
        font-size: 18px;
    }

    button:hover {
        background-color: rgba(39, 97, 255, 1);
        padding: 24px 12px;
        width: 50%;
        color: rgba(255, 255, 255, 1);
        font-weight: bold;
        cursor: pointer;
        font-size: 20px;
        scale: 1.1;
    }

    @media (max-width: 952px) {
        #container {
            display: flex;
            flex-direction: column;
            margin-left: 16px;
            margin-right: 16px;
            width: calc(100vw - 32px);
            padding-bottom: 72px;
            height: auto;
            align-items: center;
            justify-content: center;
        }
        #container-text {
            width: calc(100vw - 32px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        #header-image {
            width: calc(100vw - 32px);
            max-width: 70%;
            margin-right: 0%;
            margin-top: 48px;
        }
        h1 {
            font-size: 36px;
            text-align: center;
        }
        p {
            text-align: center;
        }
    }

</style>